import PropTypes from 'prop-types';
import CSSTransition from 'react-transition-group/CSSTransition';
import Text from '../Global/Text';

const Error = ({ touched, errors, id }) => (
  <CSSTransition
    in={!!(touched[id] && errors[id])}
    timeout={300}
    classNames="error-slideInTop"
    unmountOnExit
  >
    <label className="form__error" htmlFor={id}>
      {errors[id] &&
        <Text className="error-message" value={errors[id]}/>
      }
    </label>
  </CSSTransition>
);

export default Error;

Error.propTypes = {
  id: PropTypes.string.isRequired,
  errors: PropTypes.object.isRequired,
  touched: PropTypes.object.isRequired,
};